import { useQuery } from "@tanstack/react-query";

import { retryDelay } from "../config/queryConfig";
import { getProductOffers } from "../services/productOffersService";
import { Offer } from "../types/products";

interface UseProductOffersOptions {
  productId: string;
  retailer: string;
  enabled?: boolean;
}

export const useProductOffers = ({
  productId,
  retailer,
  enabled = true,
}: UseProductOffersOptions) => {
  const { data, isLoading, error, isFetched } = useQuery({
    queryKey: ["productOffers", productId, retailer],
    queryFn: () => getProductOffers(productId, retailer),
    enabled: Boolean(productId) && Boolean(retailer) && enabled,
    staleTime: 2 * 60 * 1000, // 2 minutes — offers change (price-sensitive)
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
    retryDelay,
  });

  const offers = data?.data?.offers ?? [];
  const buyBoxOffer: Offer | null =
    offers.find((o) => o.buy_box_winner) ?? offers[0] ?? null;
  const otherOffers = offers.filter((o) => o !== buyBoxOffer);

  return {
    buyBoxOffer,
    otherOffers,
    allOffers: offers,
    isLoading,
    error,
    isFetched,
  };
};
